import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast'
import React, { useEffect, useRef, useState } from 'react'
import { Loading } from '../../../components/Loading/Loading'
import { useHistory } from "react-router-dom";
import P221List from '../221/P221List';
import P222Search from './P222Search';
import { dataUserSession } from '../../../utilities/dataSession';
import { P222GetDataList } from '../../../service/200/P222Service';
import P222List from './P222List';

export default function P222({ dialog, setDialog, data })  {

    const history = useHistory();
    const toast = useRef(null);
    const [dataTable, setDataTable] = useState([]);
    const [dataInfo, setDataInfo] = useState({
        contractNo: "",
        contractorName: ""
    });
    const [loading, setLoading] = useState(false);

    // SEARCH
    const [searchData, setSearchData] = useState({
        contractNo: "",
        routeNo : "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {

        setSearchData({
            ...searchData,
            contractNo: data.contractNo,
            routeNo : data.routeNo,
        })
        
    }, [data]);

    useEffect(() => {
        onP222GetDataList();
    }, [searchData]);

    const onP222GetDataList = () => {
        setLoading(true);
        P222GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });

                    if(temp.length > 0){
                        setDataInfo(temp[0])
                    }

                    
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                if (err.response && err.response.data.status === 401) {
                    alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                    window.location.href = "/login";
                }
                setLoading(false);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Dialog 
                header="แสดงใบแจ้งเตือนทั้งหมด" 
                visible={dialog.dialog} 
                style={{ width: "50vw" }} 
                className="p-fluid ___widthDialog" 
                onHide={() => setDialog(false)} 
                blockScroll={true} 
                maximizable maximized 
            >
                <Loading loading={loading} />
                <div className="p-grid crud-demo">
                    <Toast ref={toast} position="top-right" />
                    <div className="p-col-12">
                        <div className="card">
                            <P222Search setDialog={setDialog} data={dataInfo} />
                            <P222List 
                                dataTable={dataTable} 
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}
